import {useIntl}from'react-intl';import {LANG}from'@manulife/mux';import useRealm from'./useRealm.js';import {REALMS}from'../utils/realmUtils.js';var formatManulifeId = function formatManulifeId(intl, realm) {
  switch (realm) {
    case REALMS.SPONSOR:
      return intl.formatMessage({
        id: 'shared.manulifeId.sponsor'
      });
    case REALMS.ADVISOR:
      return intl.formatMessage({
        id: 'shared.manulifeId.advisor'
      });
    case REALMS.MCI:
      return intl.formatMessage({
        id: 'shared.manulifeId.mortgagecreditor'
      });
    case REALMS.TRAVEL:
      return intl.formatMessage({
        id: 'shared.manulifeId.travel'
      });
    default:
      return intl.formatMessage({
        id: 'shared.manulifeId'
      });
  }
};
var appendPrefix = function appendPrefix(realm, intl) {
  if (intl.locale === LANG.EN_CA) {
    return realm === REALMS.ADVISOR ? 'an' : 'a';
  }
  return 'un';
};
function usePlainTextValues() {
  var intl = useIntl();
  var realm = useRealm();
  return {
    manulifeId: formatManulifeId(intl, realm),
    aManulifeId: "".concat(appendPrefix(realm, intl), " ").concat(formatManulifeId(intl, realm))
  };
}export{usePlainTextValues as default};